import {useContext, useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import {Button, Input} from 'semantic-ui-react'
import {DataSourceTemplates, DataSourcesContext} from '@/features/data-sources'
import {IFieldDescriptor, IMixerChannelData} from '@/features/mixer'
import {InitViewTemplate} from '../..'
import './style.css'

export const InitViewAsk: InitViewTemplate = (props: {
  descriptor: IFieldDescriptor
  finalize: (descriptor: IFieldDescriptor, initParams?: string) => void
  data?: IMixerChannelData
}) => {
  const {descriptor, finalize, data} = props

  const {activeCatalogName, addSource} = useContext(DataSourcesContext)

  const inputRef = useRef<Input>(null)
  const [query, setQuery] = useState<string>(data?.initParams || '')

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  function handleOnKeyDown(e: {key: string}) {
    if (e.key === 'Enter') handleOnSubmit()
  }

  function handleOnSubmit() {
    const q = _.trim(_.deburr(query))
    addSource(DataSourceTemplates.ask({catalog: activeCatalogName, query: q}))
    finalize(
      {
        ...descriptor,
        label: `ainar - ask: "${q}"`,
        sourcePath: `_merged.ask["${q}"]`,
      },
      q
    )
  }

  return (
    <div className='init-view ask'>
      <Input
        ref={inputRef}
        placeholder='Type your question...'
        value={query}
        onChange={(_e, {value}) => setQuery(value)}
        onKeyDown={handleOnKeyDown}
      />
      <Button
        icon='talk'
        color='blue'
        content='ask'
        onClick={handleOnSubmit}
      />
    </div>
  )
}
